module.exports = __webpack_public_path__ + "static/media/userContactIcon.719e7e43.svg";